export default {
  primary: "#3175ba",
  success: "#2ecc70",
  error: "#e74d3e",
  grayShade0: "#dce3eb"
};
